module.exports = __webpack_public_path__ + "img/jiaot3.d89e65d8.png";